import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import MetricItem from 'components/dashboard/analytics-content/AnalyticsMainMetrics/MetricItem';

import './EstimatedEarnings.css';

const EstimatedEarnings = ({
  estimatedEarnings,
  balance,
}) => {
  const { t } = useTranslation();
  const {
    last_7_days = null,
    last_90_days = null,
    this_month = null,
    yesterday = null,
  } = estimatedEarnings;

  const renderEarningsData = () => {

    return (
      <div className="estimated-earnings-section-wrapper">
        <MetricItem
          title={t("Yesterday")}
          data={`$${(yesterday && yesterday.earning) || 0}`}
          label={yesterday && yesterday.vs_previous ?
            <div className={`metric-label ${yesterday.vs_previous === 0 ? 'hidden' : ''}`}>
              <div className={`chevron ${yesterday.vs_previous > 0 ? 'up' : 'down'}`} />
              <div className="value">${yesterday.vs_previous}&nbsp;</div>
              <div className="label">{t("vs same day last week")}</div>
            </div>
            : null
          }
        />
        <MetricItem
          title={t("Last 7 days")}
          data={`$${(last_7_days && last_7_days.earning) || 0}`}
          label={last_7_days && last_7_days.vs_previous ?
            <div className={`metric-label ${last_7_days.vs_previous === 0 ? 'hidden' : ''}`}>
              <div className={`chevron ${last_7_days.vs_previous > 0 ? 'up' : 'down'}`} />
              <div className="value">${last_7_days.vs_previous}&nbsp;</div>
              <div className="label">{t("vs previous 7 days")}</div>
            </div>
            : null
          }
        />
        <MetricItem
          title={t("Last month")}
          data={`$${(this_month && this_month.earning) || 0}`}
          label={this_month && this_month.vs_previous ?
            <div className={`metric-label ${this_month.vs_previous === 0 ? 'hidden' : ''}`}>
              <div className={`chevron ${this_month.vs_previous > 0 ? 'up' : 'down'}`} />
              <div className="value">${this_month.vs_previous}&nbsp;</div>
              <div className="label">{t("vs same day last month")}</div>
            </div>
            : null
          }
        />
        <MetricItem
          title={t("Last 3 months")}
          data={`$${(last_90_days && last_90_days.earning) || 0}`}
          label={last_90_days && last_90_days.vs_previous ?
            <div className={`metric-label ${last_90_days.vs_previous === 0 ? 'hidden' : ''}`}>
              <div className={`chevron ${last_90_days.vs_previous > 0 ? 'up' : 'down'}`} />
              <div className="value">${last_90_days.vs_previous}&nbsp;</div>
              <div className="label">{t("vs previous 3 months")}</div>
            </div>
            : null
          }
        />
      </div>
    );
  };
  const renderBalanceData = () => {
    return (
      <div className="estimated-earnings-section-wrapper">
        <MetricItem
          title="no-title"
          data={`$${balance}`}
          label={`label`}
        />
      </div>
    );
  };

  return (
    <AnalyticsSection
      className="estimated-earnings__component"
      row
    >
      <AnalyticsSection
        className="estimated-earnings-section"
        header={
          <div className="title">
            <h3>{t("Estimated Earnings")}</h3>
          </div>
        }
      >
        {renderEarningsData()}
      </AnalyticsSection>

      <AnalyticsSection
        className="estimated-earnings-section balance"
        header={
          <div className="title">
            <h3>{t("Balance")}</h3>
          </div>
        }
      >
        {renderBalanceData()}
      </AnalyticsSection>
    </AnalyticsSection>
  );
};

EstimatedEarnings.propTypes = {
  estimatedEarnings: PropTypes.object,
  balance: PropTypes.number,
};
EstimatedEarnings.defaultProps = {
  estimatedEarnings: {},
  balance: 0,
};

export default EstimatedEarnings;
